import Animated from '~/components/elements/Animated'
import Content from '~/components/elements/Content'
import Links from '~/components/elements/Links'
import type { Page_Flexcontent_Flex_Content } from '~/graphql/types'

export default function ContentCtaSmall({ fields }: { fields: Page_Flexcontent_Flex_Content }) {
  return (
    <section data-component="ContentCtaSmall" className="section">
      <div className="container">
        <div className="max-w-[1069px] mx-auto">
          <Animated delay={100}>
            <div className="bg-site-grey w-full flex lg:flex-row flex-col gap-y-5 lg:justify-between lg:items-center lg:pl-16 p-6 sm:p-8">
              <Content className="max-w-[400px]">{fields.description}</Content>
              {fields.links && <Links className="max-sm:flex-col" items={fields.links} />}
            </div>
          </Animated>
        </div>
      </div>
    </section>
  )
}
